import {Cache} from "traitify-widgets";

const cache = new Cache({namespace: "dash"});

export default cache;
